<template>
  <div class="container-fluid">
    <h2 class="tittle"><live-on-icon />{{ $t("discover.live_on") }}</h2>

    <swiper
      :modules="modules"
      navigation
      :slides-per-view="slidesPerView"
      :space-between="20"
      :pagination="false"
      :scrollbar="false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(channel, i) in getLive" v-bind:key="i">
        <router-link :to="'/live/'+channel.id">
          <div class="live-card-bg">
            <div class="live-card" :style="background(channel)"></div>
          </div>
        </router-link >
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import LiveOnIcon from "@/components/icons/LiveOnIcon.vue";
import { mapState } from "pinia";
import { CategoriesStore } from "@/stores/categoriesStore";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { A11y, Navigation, Pagination, Scrollbar } from "swiper";

export default {
  name: "LiveOnChannels",
  components: { LiveOnIcon, Swiper, SwiperSlide },
  computed: {
    ...mapState(CategoriesStore, ["getLive"]),
    slidesPerView() {
      if (this.isMobile()) {
        return 2;
      } else {
        if (this.visibleImageCount > this.getLive.length) {
          return this.getLive.length - 1;
        }
        return this.visibleImageCount;
      }
    },
  },
  mounted() {
    this.updateVisibleImageCount();
    window.addEventListener("resize", this.updateVisibleImageCount);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateVisibleImageCount);
  },
  data() {
    return {
      isVisible: false,
      limit: 80,
      start: 0,
      visibleImageCount: 6,
    };
  },
  methods: {
    background(channel) {
      return {
        background: ` url(${channel.app_banner}) center center / contain no-repeat`,
      };
    },
    updateVisibleImageCount() {
      const width = window.innerWidth;

      if (width <= 960) {
        this.visibleImageCount = 3; // Mínimo para resoluciones <= 1440px
      } else if (width <= 3840) {
        this.visibleImageCount = 6; // Mínimo para resoluciones <= 1440px
      } else if (width <= 3840) {
        // Escala entre 1440 y 3840
        this.visibleImageCount = 6;
      } else {
        this.visibleImageCount = 14; // Máximo para resoluciones >= 3840px
      }
    },
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style scoped lang="scss">
.live-card-bg {
  min-height: 140px;
  height: 10vh;
  max-height: 10vw;
  width: 100%;
  background: url("/img/live/bg.png") no-repeat center center / cover;
  border-radius: 10px;
  padding: 2em;
  overflow: hidden;
  .live-card {
    height: 100%;
    width: 100%;
  }
}
.tittle {
  font-weight: 400;
  margin: 1.5em 0 1.5em 0em;

  .live-on-icon {
    margin-right: 0.5em;
  }
}
</style>
